import { Component, Inject, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { GroupsService } from '../../../services/groups.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';

import { MatOptionModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { Group } from '../../../models/group';
import { DragDropModule } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-dept-chooser',
  templateUrl: './dept-chooser.component.html',
  styleUrls: ['./dept-chooser.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatOptionModule,
    MatSelectModule,
    MatListModule,
    DragDropModule
]
})
export class deptChooserComponent implements OnInit {
  depts: Group[] = [];
  filteredDepts: any[] = [];
  searchTerm = '';
  selectedDept: any = null;

  constructor(
    private http: HttpClient,
    private deptsService: GroupsService,
    public dialogRef: MatDialogRef<deptChooserComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    // Fetch the list of depts from the endpoint
    this.deptsService.groups$.subscribe({
      next: (response) => {
        this.depts = response;
        this.filteredDepts = response;
      },
      error: (err) => console.error('Error fetching depts:', err)
    });
    this.deptsService.fetchGroups();
  }

  onSearchTermChange(): void {
    const terms = this.searchTerm.toLowerCase().split(' ').filter(t => t !== '');
    this.filteredDepts = this.depts.filter(dept =>
      terms.every(term => 
        dept.name?.toLowerCase().includes(term) ||
        dept.key?.toLowerCase().includes(term))
    );
  }

  onSelectDept(dept: any): void {
    this.selectedDept = dept;
  }

  onCancelClick(): void {
    // Close dialog without returning anything
    this.dialogRef.close();
  }

  onSelectClick(): void {
    // Return the selected dept object to the caller
    if (this.selectedDept) {
      this.dialogRef.close(this.selectedDept);
    }
  }
}
